/* RESPONSIBLE TEAM: team-ai-agent-2 */

export const TOPICS_EXPLORER_HELP_URL =
  'https://www.intercom.com/help/en/articles/11390087-use-the-topics-explorer-to-see-what-s-driving-volume';

export interface TopicSummary {
  topic_id: string;
  topic_name: string;
  conversation_count: number;
}

export interface TopicSummaryResponse {
  topics: TopicSummary[];
}
